module.exports = __webpack_public_path__ + "assets/img/44c.f323b0d9.jpg";